import "./App.css";
import Hero from "./pages/Hero";
import NavSmall from "./routes/NavSmall";
import About from "./pages/About";
import NavbarS from "./routes/Navbar";
import Project from "./pages/Project";
import SocialHandle from "./pages/socialHandle";
import Contact from "./pages/Contact";
import Skills from "./pages/Skills";
import { IconButton, useColorMode, useColorModeValue } from "@chakra-ui/react";
import { MdDarkMode } from "react-icons/md";
import { BsLightbulb } from "react-icons/bs";
import { AnimateCursor } from "./routes/AnimateCursor";

function App() {
  const { colorMode, toggleColorMode } = useColorMode();

  const CursorColor = useColorModeValue("231, 77, 77", "234,194,136");

  return (
    <AnimateCursor CursorColor={CursorColor}>
      <NavbarS />
      <Hero />
      <About />
      <Project />
      <Skills />
      <Contact />
      <NavSmall />
      <SocialHandle />
      <IconButton
        zIndex={999}
        fontSize="30px"
        position={"fixed"}
        top={{ base: 3, md: 3, lg: 3 }}
        right={{ base: 5, md: "5", lg: "5" }}
        borderRadius={50}
        colorScheme="red"
        onClick={toggleColorMode}
        icon={colorMode === "light" ? <MdDarkMode /> : <BsLightbulb />}
      />
    </AnimateCursor>
  );
}

export default App;
